export let filterNames = {
  "Project Sponsoring Ministry": "projectSponsoringMinistry",
  "Project Sector": "projectSector",
  "Recipient Ministry/State": "recipientMinistryState",
  "Issue Sponsoring Ministry": "issueSponsoringMinistry",
  "Recipient Ministry": "recipientMinistry",
  "Recipient State-Department": "recipientStateDepartment",
  "Recipient State": "recipientState",
  "Guest(s)": "guests",
  "Created By": "createdBy",
  "Project Proponent": "projectProponent",
  Proponent: "proponent",
  Milestone: "milestone",
  "Project Sponsoring Department": "sponsoringDepartment",
  "Issue Sponsoring Department": "sponsoringDepartment",
  "Project Status": "projectTags",
  "Project Status": "projectStatus",
  "Project Location": "projectLocation",
  "Issue Location": "centerState",
  "Monitoring Flag": "projectFlags",
  "Project Stage": "projectstage",
  "Implementation Mode": "impmode",
  "Issue Stages": "stages",
  "Issue Category": "category",
  "Escalation Level": "escalationLevel",
  "Project District": "districtProjectLocation"
};
